import React from 'react';
import { motion } from 'framer-motion';
import { CategoryCarousel } from './CategoryCarousel';
interface Category {
  title: string;
  images: {
    src: string;
    alt: string;
  }[];
}
const categories: Category[] = [{
  title: 'Cocinas',
  images: [{
    src: 'https://i.postimg.cc/kGyKNjrb/COCINA-1-CUADRADA.jpg',
    alt: 'Cocina G&M 1'
  }, {
    src: 'https://i.postimg.cc/ZnLpPfkx/COCINA1.jpg',
    alt: 'Cocina G&M 2'
  }, {
    src: 'https://i.postimg.cc/6qhnVHsC/COCINA-2.jpg',
    alt: 'Cocina G&M 3'
  }, {
    src: 'https://i.postimg.cc/XqgdK2Mw/COCINA-2-C.jpg',
    alt: 'Cocina G&M 4'
  }, {
    src: 'https://i.postimg.cc/8cbMdy8d/COCINA-4-C.jpg',
    alt: 'Cocina G&M 5'
  }, {
    src: 'https://i.postimg.cc/J0QZ3Twq/COCINA-5.jpg',
    alt: 'Cocina G&M 6'
  }]
}, {
  title: 'Muebles Convertibles',
  images: [{
    src: 'https://i.postimg.cc/7hp8VNgZ/MUEBLE-CONVERTIBLE1.jpg',
    alt: 'Mueble convertible 1'
  }, {
    src: 'https://i.postimg.cc/mDpGc4k4/MUEBLE-CONVERTIBLE-1-C.jpg',
    alt: 'Mueble convertible 2'
  }, {
    src: 'https://i.postimg.cc/0N8gcjJ5/IMG-5829.jpg',
    alt: 'Sistema abatible 3'
  }, {
    src: 'https://i.postimg.cc/PrYr7LND/IMG-5836.jpg',
    alt: 'Sistema abatible 4'
  }]
}, {
  title: 'Decoración de Espacios',
  images: [{
    src: 'https://i.postimg.cc/3NYXB0VQ/Whats-App-Image-2026-07-10-at-08-30-10.jpg',
    alt: 'Mueble para TV 1'
  }, {
    src: 'https://i.postimg.cc/cHZtyyhq/Whats-App-Image-2026-07-10-at-08-30-11.jpg',
    alt: 'Mueble para TV 2'
  }, {
    src: 'https://i.postimg.cc/LsmmmHc4/Whats-App-Image-2026-07-10-at-08-30-11-(2).jpg',
    alt: 'Mueble para TV 3'
  }, {
    src: 'https://i.postimg.cc/fbWpykBf/01b53612-2823-476d-a6ef-1ff27c8390be.jpg',
    alt: 'Decoración de espacios 4'
  }, {
    src: 'https://i.postimg.cc/WbMH70yb/IMG-1546.jpg',
    alt: 'Decoración de espacios 5'
  }]
}, {
  title: 'Baños',
  images: [{
    src: 'https://i.postimg.cc/J0R1zRHC/IMG-1574.jpg',
    alt: 'Baño 1'
  }, {
    src: 'https://i.postimg.cc/288kp8fQ/IMG-1576.jpg',
    alt: 'Baño 2'
  }, {
    src: 'https://i.postimg.cc/DwRnbr4Z/IMG-1579.jpg',
    alt: 'Baño 3'
  }, {
    src: 'https://i.postimg.cc/0Q0s3hWm/IMG-1580.jpg',
    alt: 'Baño 4'
  }]
}, {
  title: 'Empresas / Proyectos Comerciales',
  images: [{
    src: 'https://i.postimg.cc/N0fNkSh4/IMG-2324.jpg',
    alt: 'Proyecto comercial 1'
  }, {
    src: 'https://i.postimg.cc/bY2mg159/IMG-2398.jpg',
    alt: 'Proyecto comercial 2'
  }, {
    src: 'https://i.postimg.cc/wTX08ggh/IMG-4253.jpg',
    alt: 'Proyecto comercial 3'
  }, {
    src: 'https://i.postimg.cc/jSvc2cW7/IMG-4218.jpg',
    alt: 'Proyecto comercial 4'
  }, {
    src: 'https://i.postimg.cc/JhDX85ZQ/IMG-2367.jpg',
    alt: 'Proyecto comercial 5'
  }]
}];
export function PortfolioGrid() {
  return <section id="portafolio" className="py-24 bg-bone" data-id="element-163" data-mp="2dg736p1gaoj9">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-164" data-mp="2ie8kp5j8afsm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-165" data-mp="2idfjek31gihv">
          <h2 className="text-3xl md:text-5xl font-bold text-espresso mb-4" data-id="element-166" data-mp="x15tdcxbsifv">
            Portafolio
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-167" data-mp="120ie9s4mzfft"></div>
          <p className="text-espresso/70 font-light mt-6 max-w-2xl mx-auto" data-id="element-168" data-mp="2sgkm7f4gxzbk">
            Explore nuestros proyectos organizados por línea de servicio.
            Deslice para descubrir cada categoría.
          </p>
        </motion.div>

        <div data-id="element-169" data-mp="31g7py7ko7h7s">
          {categories.map((cat, i) => <CategoryCarousel key={cat.title} title={cat.title} images={cat.images} index={i} data-id="element-170" data-mp="2xfnv5ankkpot" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}